module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hS7Ey"))).then(() => parcelRequire('2KbAe'));